var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"zX9axOAHDc396XQum9qDZ"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/messenger-build/20a1c805edd242afcfab928f313a9e4e9744ec16";

import * as Sentry from '@sentry/nextjs';

const env = process.env.NEXT_PUBLIC_TARGET_ENV || 'development';
const isProduction = env === 'production';
const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

if (isProduction) {
  if (!SENTRY_DSN) {
    throw new Error('SENTRY_DSN is not set');
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: env,
    tracesSampleRate: 1.0,
  });
}
